import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "left",
  "use": "left-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"left\"><defs><style type=\"text/css\"></style></defs><path d=\"M430.55 511.872L663.935 745.387l-45.29 45.226-278.61399999-278.762 278.63499999-278.464 45.226 45.269z\" fill=\"#ffffff\" p-id=\"671\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol